import { BaseEntity, isEntityOfType } from ".";
import { IGet_corporations_corporation_id_ok } from "../service/esiclient";
import moment from "moment";

export class CorporationEntity extends BaseEntity {
  constructor(id: number, props: any) {
    super(id, props);
    this._dataTypeName = "Corporation";
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const id = this._id;
    const props: Partial<IGet_corporations_corporation_id_ok> = this.props;

    var entity = await super.toJson();

    // Properties
    if (entity.properties) {
      // - Image
      entity.properties["image"] = {
        type: Excel.CellValueType.webImage,
        address: `https://images.evetech.net/corporations/${id}/logo`,
        altText: props.name,
      };
      if (props.date_founded) {
        const date_founded = moment(props.date_founded);
        entity.properties["date_founded"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: date_founded.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      // TODO: Uncommenting the following code will introduce an infinite loop since
      // the Character entity contain a reference to Corporation
      // - CEO
      // if (props.ceo_id) {
      //   const ceoEntity = await getCachedCharacterEntity(props.ceo_id);
      //   if (ceoEntity !== null) {
      //     entity.properties["ceo"] = await ceoEntity.toJson();
      //     delete entity.properties["ceo_id"];
      //   }
      // }
      // // - Creator
      // if (props.creator_id) {
      //   const creatorEntity = await getCachedCharacterEntity(props.creator_id);
      //   if (creatorEntity !== null) {
      //     entity.properties["creator"] = await creatorEntity.toJson();
      //     delete entity.properties["creator_id"];
      //   }
      // }
    }

    // Layouts
    entity.layouts = {
      card: {
        title: { property: "name" },
        mainImage: { property: "image" },
      },
    };

    return entity;
  }
}

export function isCorporationEntity(entity: any): boolean {
  return isEntityOfType(entity, "Corporation");
}
